import React from 'react';
import CampoEditableTexto from '../UI/campos/CampoEditableTexto.js';
import * as Campos from '../constantes/Campos.js';
import * as LargoCampos from '../largoCampos/LargoCamposEstadio.js';
import styles from './DatosEstadio.module.css';

const CamposEstadioPropetarios = (props) => {
  const estadio = props.estadio;
  const editar = props.editar;
  const propietario = estadio && estadio.propietario;

  const onCampoChange = (campo, valor) => {
    props.onCampoChange(campo, valor);
  };

  if (!editar && !propietario) {
    return null;
  }

  return (
    <table className={`${styles.tablaDatos}`}>
      <tbody>
        <tr>
          <td className={`${styles.titulo}`}>Propietario</td>
          <td className={`${styles.valor}`}>
            <CampoEditableTexto
              nombre={Campos.Estadio.PROPIETARIO}
              valor={estadio && estadio.propietario}
              largo={LargoCampos.PROPIETARIO}
              editar={editar}
              width="90%"
              onChange={onCampoChange}
            />
          </td>
        </tr>
      </tbody>
    </table>
  );
};

export default CamposEstadioPropetarios;
